import type {Dayjs} from 'dayjs'
import type {UserSettings} from '@package/shared'

export const formatLocalMonth = (date: Dayjs, userSettings: UserSettings): string => {
  return date
    .toDate()
    .toLocaleDateString(undefined, {month: 'long', year: 'numeric', day: undefined, timeZone: userSettings.timezone})
}
